require('./brokerMarketsTrend.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { connect } = require('react-redux');
const { formatText, FormattedText } = require('core/i18n').i18n;
const { ContentBox } = require('commonsComponents/contentBox');
const StocksMeter2 = require('components/broker/stocksMeter2/stocksMeter2');
const BrokerInvestBehaviorGraphics = require('components/broker/brokerInvestBehaviorGraphics/brokerInvestBehaviorGraphics');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';
// @actions
const brokerMarketsTrendActions = require('actions/brokerMarketsTrend');
const { TREND_INVESTORS } = require('constants/flagBasedFeatures');
// @helpers
const { taggingEventHandled } = require('utilities/taggingEventHandled');
class BrokerMarketsTrend extends React.Component {

    componentDidMount() {
        this.props.getActivities();
        this.props.getActivitiesByTrending();
    }

    render() {
        const marketTrendsTitle = formatText('broker-marketTrendTitle');
        const meterSubtitle = formatText('broker-marketTrendMeterSubtitle');
        const meterText = formatText('broker-marketTrendMeterText');
        const behaviorTitle = formatText('broker-marketTrendBehaviorTitle');
        const behaviorSubtitle = formatText('broker-marketTrendBehaviorSubtitle');

        const { trendData } = this.props;
        const stock = trendData.get('stock');
        const stocksPercentage = +Number(stock).toFixed(0);
        const invests = trendData.get('invests');
        const marketsTrendTooltip = <FormattedText value="marketsTrend-marketsTrendTooltip" />;
        const iconInfo = (
            <OKTooltip
                target={(
                    <i 
                        className="icon icon-tooltip broker-market-trends__tooltip"
                        onMouseEnter={() => taggingEventHandled(this.props.pageName, 'tooltipTrendsCard')}
                    />
                )}
                content={marketsTrendTooltip}
                placement="left"
                offset={[-10,10]}
            />
        );

        return (
            <ContentBox
                id="brokerMarketTrends"
                title={marketTrendsTitle}
                smallTitle={true}
                customClassName="broker-market-trends"
                tooltip={iconInfo}
            >
                <div className="broker-market-trends__period-container">
                    <FormattedText
                        value="broker-marketTrendTimePeriod"
                        className="broker-market-trends__period-text"
                    />
                </div>
                <div className="broker-market-trends__meter-container">
                    <h3 className="broker-market-trends__subtitle">
                        {meterSubtitle}
                    </h3>
                    <p className="broker-market-trends__text">
                        {meterText}
                    </p>
                    <StocksMeter2 percentage={stocksPercentage} />
                </div>
                <div className="broker-market-trends__behavior-invest-container">
                    <div className="broker-market-trends__behavior-invest-header">
                        <h3 className="broker-market-trends__behavior-title">
                            {behaviorTitle}
                        </h3>
                        <p className="broker-market-trends__behavior-subtitle">
                            {behaviorSubtitle}
                        </p>
                    </div>
                    <FeatureTogglingRender notAllowedProductKey={TREND_INVESTORS}  productKeyFilter="every">
                        <BrokerInvestBehaviorGraphics invests={invests} onHandleBuyClick={this.props.onHandleBuyClick} />
                    </FeatureTogglingRender>
                </div>
            </ContentBox>
        );
    }
}

BrokerMarketsTrend.propTypes = {
    trendData: PropTypes.object,
    getActivities: PropTypes.func,
    getActivitiesByTrending: PropTypes.func,
    onHandleBuyClick: PropTypes.func,
    pageName: PropTypes.string
}

module.exports.constructor = BrokerMarketsTrend;
module.exports.BrokerMarketsTrend = connect(
    state => ({
        trendData: state.brokerMarketsTrend,
    }), {
        getActivities: brokerMarketsTrendActions.getActivities,
        getActivitiesByTrending: brokerMarketsTrendActions.getActivitiesByTrending
    }
)(BrokerMarketsTrend);
